<template>
	<div class="basic-info">
		<div class="left">
			<div class="top">
				<div class="title">基本属性</div>
				<el-row :gutter="20">
					<el-col :span="8">
						<div class="info-item">
							<div class="label" style="width: 100px">设备类型名称：</div>
							<div class="value" style="width: calc(100% - 110px)">
								<gc-custom-tooltip
									refName="deviceTypeName"
									:content="tabData.deviceTypeName"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">设备通讯编号：</div>
							<div class="value">
								<gc-custom-tooltip refName="deviceNo" :content="tabData.deviceNo"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">外观编号：</div>
							<div class="value">
								<gc-custom-tooltip refName="designNo" :content="tabData.designNo"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-if="tabData.firstCategory === '0410'">
						<div class="info-item">
							<div class="label">条形编码：</div>
							<div class="value">
								<gc-custom-tooltip
									refName="gasDeviceNo"
									:content="tabData.gasDeviceNo"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-for="item in basicInfoList" :key="item.key">
						<div class="info-item info-item-basic">
							<div class="label">{{ item.label }}</div>
							<div class="value">
								<gc-custom-tooltip :refName="item.key" :content="item.value"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="bottom">
				<div class="title">安装属性</div>
				<el-row :gutter="20">
					<el-col :span="8">
						<div class="info-item">
							<div class="label">安装日期：</div>
							<div class="value">
								{{
									(this.source === 'timeoutDevice'
										? tabData.firstInstallDate
										: tabData.installDate) || '-'
								}}
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">用户号：</div>
							<div class="value">
								<gc-custom-tooltip refName="userNo" :content="tabData.userNo"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">客户类型：</div>
							<div class="value">
								<gc-custom-tooltip refName="userType" :content="getUserTypeName()"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">
								{{
									tabData.installLocation >= 10 || siteShow(tabData.deviceTypeId)
										? '站点名称：'
										: '客户名称：'
								}}
							</div>
							<div class="value">
								<gc-custom-tooltip refName="username" :content="tabData.username"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">所属组织：</div>
							<div class="value">
								<gc-custom-tooltip refName="orgName" :content="tabData.orgName"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">手机号码：</div>
							<div class="value">
								<gc-custom-tooltip refName="userPhone" :content="tabData.userPhone"></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="info-item">
							<div class="label">联系电话：</div>
							<div class="value">
								<gc-custom-tooltip
									refName="userPhone2"
									:content="tabData.userPhone2"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-if="tenantType === '0'">
						<div class="info-item">
							<div class="label">是否独居老人：</div>
							<div class="value">
								<gc-custom-tooltip
									refName="homeType"
									:content="!isBlank(tabData.homeType) ? homeTypeMap[tabData.homeType] : '-'"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-if="userInfo.tenantType === '1'">
						<div class="info-item">
							<div class="label">初始表底：</div>
							<div class="value">
								<gc-custom-tooltip
									refName="startMeterReading"
									:content="tabData.startMeterReading"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-if="userInfo.tenantType === '1'">
						<div class="info-item">
							<div class="label">所属区域：</div>
							<div class="value">
								<gc-custom-tooltip
									refName="waterRegionName"
									:content="tabData.waterRegionName"
								></gc-custom-tooltip>
							</div>
						</div>
					</el-col>
					<el-col :span="8" v-if="tabData.installLocation >= 10 || siteShow(tabData.deviceTypeId)">
						<div class="info-item">
							<div class="label">站点编号：</div>
							<div class="value">
								{{ tabData.installLocationNo || '-' }}
							</div>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="info-item">
							<div class="label">安装位置：</div>
							<div class="value">
								{{ parseInstallLocationName(tabData.installLocation) || '-' }}
							</div>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="info-item">
							<div class="label">安装地址：</div>
							<div class="value">
								{{ tabData.addressName || '-' }}
							</div>
						</div>
					</el-col>
					<el-col :span="24">
						<div class="info-item">
							<div class="label">设备位置：</div>
							<div class="value">{{ tabData.installPosition || '-' }}</div>
						</div>
					</el-col>
					<el-col :span="24" v-if="tabData.image && tabData.image.length">
						<div class="info-item install-pic">
							<div class="label">安装图片：</div>
							<div class="pic-list">
								<gc-image :urls="tabData.image"></gc-image>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="right">
			<div class="title">
				<span>时点运行状态</span>
				<span class="refresh-time" v-if="tabData.deviceStatus === 1 && refreshTime">
					刷新时间：{{ refreshTime }}
				</span>
			</div>
			<div v-if="tabData.deviceStatus === 1 && cardList.length > 0" class="card">
				<Status-Card v-for="item in cardList" :key="item.attributeKey" :card-info="item"></Status-Card>
			</div>
			<gc-empty v-else style="margin-top: 220px"></gc-empty>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isBlank } from '@/utils/validate'
import { apiGetDeviceStatus, apiGetIotDeviceStatus } from '@/apis/account.api'
import { siteShow } from '@/utils/business'
import StatusCard from '../../components/StatusCard'

export default {
	name: 'basicInfo',
	components: { StatusCard },
	props: {
		tabData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			cardList: [],
			refreshTime: null,
		}
	},

	computed: {
		...mapGetters({
			userInfo: 'userInfo',
			dataList: 'dataList',
		}),

		tenantType() {
			return this.$store.getters.userInfo.tenantType
		},

		basicInfoList() {
			const list = this.tabData.dynamicBaseAttributes || []
			return list.map(item => {
				let val = item.value
				if (!isBlank(val)) {
					if (item.interactiveTranslationDes) {
						val = item.interactiveTranslationDes[val]
					}
					val = item.unitName ? val + item.unitName : val
				} else {
					val = null
				}
				return {
					label: item.name + '：',
					value: val,
					key: item.attributeKey,
				}
			})
		},

		isGateway() {
			return this.$route.query.gateway === '1'
		},

		iotDeviceId() {
			return this.$route.query.iotDeviceId
		},

		source() {
			return this.$route.query.source
		},

		homeTypeMap() {
			return (
				this.$store.getters.dataList?.homeType?.reduce((prev, cur) => {
					return {
						...prev,
						[cur.defaultValue]: cur.name,
					}
				}, {}) || {}
			)
		},
	},

	created() {
		this.getDeviceStatusList()
	},

	methods: {
		isBlank,
		siteShow,

		parseInstallLocationName(value) {
			if (isBlank(value) || this.tabData.deviceStatus === 0) return null
			const installLocation = this.$store.getters.dataList[
				this.tenantType === '0' ? 'installLocationGas' : 'installLocation'
			]
			const target = (installLocation || []).find(item => item.defaultValue == value)
			return target?.name
		},

		async getDeviceStatusList() {
			if (!this.$has('monitor:device:account:select')) return
			const deviceId = this.$attrs.common
			const data =
				this.isGateway && this.iotDeviceId
					? await apiGetIotDeviceStatus(this.iotDeviceId)
					: await apiGetDeviceStatus(deviceId)
			this.refreshTime = data.queryTime
			this.cardList = (data.records || []).map(m => {
				return {
					...m,
					deviceId,
					value: m.interactiveTranslationDes ? m.interactiveTranslationDes[m.value] : m.value,
				}
			})
		},

		getUserTypeName() {
			return (
				((this.dataList.userType || []).find(item => item.defaultValue == this.tabData.userType) || {}).name ||
				null
			)
		},
	},
}
</script>
<style lang="scss" scoped>
.basic-info {
	display: flex;
	justify-content: space-between;
	background-color: #fff;
	height: 100%;
	overflow: auto;
	.left {
		flex: 1;
		min-width: 889px;
		display: flex;
		flex-direction: column;
		padding: 0 24px;
		.top {
			padding: 24px 0;
		}
		.bottom {
			margin-top: 20px;
		}
	}
	.right {
		flex: 1;
		max-width: 790px;
		padding-top: 30px;
		.card {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(238px, 1fr));
		}
	}
	.title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 15px;
		font-weight: 600;
		color: #333333;
		margin-bottom: 12px;
		.refresh-time {
			font-size: 14px;
			font-weight: 400;
			color: #999999;
			margin-right: 12px;
		}
	}
	.info-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		line-height: 20px;
		padding: 8px 0;
		.label {
			font-size: 14px;
			font-family: SourceHanSansCN-Regular, SourceHanSansCN;
			font-weight: 400;
			color: #666666;
			flex-shrink: 0;
		}
		.value {
			flex: 1;
			width: 0;
			font-size: 14px;
			font-family: SourceHanSansCN-Regular, SourceHanSansCN;
			font-weight: 400;
			color: #333333;
		}
	}
	.install-pic {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		.pic-list {
			img {
				padding-top: 10px;
				vertical-align: top;
				width: 200px;
			}
			img + img {
				padding-left: 10px;
			}
		}
	}
}
</style>
